import { makeVar } from "@apollo/client";
import { KEY_AUTH_TOKEN } from "_constants";

const initConfig = window.localStorage.getItem(KEY_AUTH_TOKEN);
export const varAuthToken = makeVar(initConfig);
